export function getIframeBaseUrl(): string {
  // Only add prefix in development mode
  if (import.meta.env.DEV) {
    const domain = import.meta.env.VITE_DOMAIN
    if (domain === 'test') {
      return 'https://admin-decko-test.nm-ct.cz'
    } else if (domain === 'prod') {
      return 'https://decko.ceskatelevize.cz'
    }
  }
  // In production or when domain is not set, use relative path
  return ''
}
